import { ActionContext } from 'vuex';

import { CONTAINER, TYPES } from '../../../config';

import { ActionClass, AuthState } from '../../../models';

import { StorageService } from '../../../services';

import { AUTH_CONSTS } from '../../auth/auth.consts';

export class LogoutAction implements ActionClass {

  public static execute({ commit }: ActionContext<AuthState, any>): void {
    commit(AUTH_CONSTS.mutations.clearModule);
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService);
    storageService.removeItem(AUTH_CONSTS.storage.token);
    storageService.removeItem(AUTH_CONSTS.storage.refreshToken);
    storageService.removeItem(AUTH_CONSTS.storage.keepLoggedIn);
  }

}
